@if (vm$ | async; as vm) {
	<router-outlet />
	<main class="container">
		<!-- BACK BUTTON -->
		<button (click)="this.location.back()" class="back-button">
			<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
			Voltar
		</button>

		<!-- HEADER -->
		<div class="container__header">
			<h1 class="title">Reserva</h1>
			<h2 class="venue-title">{{ vm.venue?.name }}</h2>
		</div>

		<!-- TABS -->
		<div class="container__tabs">
			<div class="container__tabs__tab" [ngClass]="{ active: activeTab() >= 1 }">
				<span>1</span>
			</div>

			<div class="line"></div>

			<div class="container__tabs__tab" [ngClass]="{ active: activeTab() >= 2 }">
				<span>2</span>
			</div>

			<div class="line"></div>

			<div class="container__tabs__tab" [ngClass]="{ active: activeTab() >= 3 }">
				<span>3</span>
			</div>
		</div>

		@if (vm.statusConfirmReservation === 'pending' || vm.statusAvailabilities === 'pending') {
			<!-- Loading -->
			<section style="margin-top: 32px">
				<ui-porto-bank-loading-page />
			</section>
		} @else {
			<!-- Form -->
			<form
				class="container__form"
				[formGroup]="form"
				*ngIf="vm.statusConfirmReservation !== 'success'"
			>
				<h3>Detalhes da reserva</h3>

				<div style="padding: 40px 20px; display: flex; flex-direction: column; gap: 42px">
					<!-- NOME -->
					<div class="form-field">
						<label for="name" class="form-field__label">Nome</label>
						<input
							matInput
							id="name"
							class="form-field__input"
							formControlName="name"
							(focus)="getFieldState('name').setFocused(true)"
							(blur)="getFieldState('name').setFocused(false)"
							[ngClass]="{
								focused: getFieldState('name').focused(),
								filled: form.controls.name.value,
								editing: getFieldState('name').editing(),
								error: form.controls.name.errors && form.controls.name.dirty
							}"
							[ngClass]="{ 'disabled-wrapper': form.controls.name.disabled }"
						/>
						<div class="error-container">
							@if (form.controls.name.errors?.['required'] && form.controls.name.dirty) {
								<span class="error-message">Nome é obrigatório</span>
							}
						</div>
					</div>

					<!-- DATA -->
					<div class="form-field">
						<label for="date" class="form-field__label">Data</label>

						<div class="input-wrapper">
							<mat-icon class="form-field__icon" svgIcon="porto-bank-icons:calendar"></mat-icon>

							<input
								matInput
								id="date"
								class="form-field__input"
								formControlName="date"
								placeholder="Selecione a data"
								readonly
								[value]="displayDate"
								(click)="showCalendar.set(!showCalendar())"
								(focus)="getFieldState('date').setFocused(true)"
								(blur)="getFieldState('date').setFocused(false)"
								[ngClass]="{
									focused: getFieldState('date').focused(),
									filled: form.controls.date.value,
									editing: getFieldState('date').editing(),
									error: form.controls.date.errors && form.controls.date.dirty
								}"
							/>

							<mat-icon
								class="form-field__icon-right"
								svgIcon="porto-bank-icons:down-arrow"
							></mat-icon>
						</div>

						<div class="error-container">
							@if (form.controls.date.errors?.['required'] && form.controls.date.dirty) {
								<span class="error-message">Data é obrigatória</span>
							}
						</div>

						<div
							style="padding: 20px; box-shadow: 1px 1px 4px #00000031; border-radius: 8px"
							*ngIf="showCalendar() && vm.availabilitiesDates as availabilities"
						>
							<ui-porto-bank-calendar
								[availabilitiesDates]="availabilities"
								(daySelected)="onDaySelected($event.dateString)"
								[selectedDate]="vm.selectedDate"
							></ui-porto-bank-calendar>
						</div>
					</div>

					<!-- AMBIENTE (mat-select) -->
					<div class="form-field">
						<label for="section" class="form-field__label">Ambiente</label>

						<div class="full-width" style="margin: 0">
							<mat-select
								id="section"
								placeholder="Selecione o ambiente"
								formControlName="section"
								(selectionChange)="
									onSectionChange($event.value); setPartysize(vm.maxMinPartysize?.min ?? 1)
								"
								panelClass="custom-select-panel"
							>
								<mat-option *ngFor="let option of vm.sections" [value]="option.label">
									{{ option.label }}
								</mat-option>
							</mat-select>

							<mat-icon
								svgIcon="porto-bank-icons:down-arrow"
								class="full-width__icon"
							></mat-icon>
						</div>

						<div class="error-container">
							@if (form.controls.section.errors?.['required'] && form.controls.section.dirty) {
								<span class="error-message">Ambiente é obrigatório</span>
							}
						</div>
					</div>

					<!-- NÚMERO DE PESSOAS -->
					<div class="form-field">
						<label for="partySize" class="form-field__label">Número de pessoas</label>

						<div class="full-width" style="margin: 0">
							<mat-select
								id="partySize"
								formControlName="partySize"
								placeholder="Quantas pessoas?"
								(selectionChange)="setPartysize($event.value)"
							>
								<mat-option
									*ngFor="
										let option of [].constructor(vm.maxMinPartysize?.max);
										let i = index
									"
									[value]="i + 1"
								>
									{{ i + 1 }} {{ i + 1 === 1 ? 'pessoa' : 'pessoas' }}
								</mat-option>
							</mat-select>

							<mat-icon
								svgIcon="porto-bank-icons:down-arrow"
								class="full-width__icon"
							></mat-icon>
						</div>
						<div class="error-container">
							@if (
								form.controls.partySize.errors?.['required'] && form.controls.partySize.dirty
							) {
								<span class="error-message">Número de pessoas é obrigatório</span>
							}
						</div>
					</div>

					<!-- HORARIO -->
					<div class="form-field">
						<label for="reservationTime" class="form-field__label">Horário</label>

						<div class="full-width" style="margin: 0">
							<mat-select
								id="reservationTime"
								formControlName="reservationTime"
								placeholder="Selecione o horário"
								(selectionChange)="setReservationTime($event.value)"
							>
								<mat-option *ngIf="!vm.reservationTimes" disabled>
									Nenhum horário disponível
								</mat-option>

								<mat-option
									*ngFor="let option of vm.reservationTimes"
									[value]="option.reservationTime"
								>
									{{ option.reservationTime }}
								</mat-option>
							</mat-select>

							<mat-icon
								svgIcon="porto-bank-icons:down-arrow"
								class="full-width__icon"
							></mat-icon>
						</div>
						<div class="error-container">
							@if (
								form.controls.reservationTime.errors?.['required'] &&
								form.controls.reservationTime.dirty
							) {
								<span class="error-message">Horário é obrigatório</span>
							}
						</div>
					</div>
				</div>

				<div style="height: 1px; width: 100%; margin-bottom: 20px; background-color: #e0e0e0"></div>

				<!-- Termos e condições -->
				<ui-porto-bank-confirm-slider
					(checkValueChange)="toggleTermsAndConditions($event)"
					*ngIf="showTerms()"
				>
					<p>
						Li e aceito os
						<span
							routerLink="/termos-de-uso"
							style="text-decoration: underline; color: var(--content-primary)"
						>
							termos e condições
						</span>
						para utilizar benefício.
					</p>
				</ui-porto-bank-confirm-slider>

				<div class="button-container">
					<button
						mat-button
						class="submit-button"
						[style.background-color]="
							isDisabled()
								? 'var(--background-button-disabled)'
								: 'var(--background-button-primary)'
						"
						[disabled]="isDisabled()"
						(click)="confirmReservation()"
					>
						Confirmar
					</button>
				</div>
			</form>
		}
	</main>

	<!-- ORDER SUCCESS -->
	<section
		*ngIf="
			vm.statusConfirmReservation === 'success' &&
			vm.venue &&
			vm.client &&
			vm.confirmReservation.partySize &&
			vm.confirmReservation.reservationTime &&
			vm.confirmReservation.reservationDay &&
			vm.confirmReservation.sectionLabel
		"
		style="padding: 0 20px"
	>
		<ui-porto-bank-order-success
			type="reservation"
			[partySize]="partysize()"
			[venue]="vm.venue"
			[client]="vm.client"
			[partySize]="vm.confirmReservation.partySize"
			[reservationTime]="vm.confirmReservation.reservationTime"
			[sectionLabel]="vm.confirmReservation.sectionLabel"
			[orderDate]="vm.confirmReservation.reservationDay"
			[voucherValue]="vm.voucherValue"
			[benefit]="vm.venue.benefits"
			(ok)="okClick()"
		/>
	</section>

	<div style="height: 120px; width: 100%"></div>
}
